import React from "react";

const Screen12 = () => {
    return <div></div>;
};

export default Screen12;
